import React from "react";
import { useTranslation } from "react-i18next";
import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";

const RegionField = ({ value, setValue, error, regions }) => {
    // eslint-disable-next-line no-unused-vars
    const { t } = useTranslation();

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    if (!regions) return null;

    return (
        <FormControl error={!!error} variant="outlined" fullWidth>
            <InputLabel id="region-select-label">Region</InputLabel>
            <Select
                labelId="region-select-label"
                label="Region"
                id="region-select"
                data-testid="region-select"
                onChange={handleChange}
                variant="outlined"
                value={value}
                fullWidth
            >
                {regions.map((region) => (
                    <MenuItem value={region.value} key={region.label}>
                        {region.label}
                    </MenuItem>
                ))}
            </Select>
            <FormHelperText data-testid="field-error">{error || " "}</FormHelperText>
        </FormControl>
    );
};

export default RegionField;
